<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useDisableRules } from "@/composables/reactive/useDisableRules";
import TooltipButton from "@/components/buttons/TooltipButton.vue";
import type { OrderStatus } from "@/constants/order";

const props = defineProps<{
  orderStatus?: OrderStatus;
}>();

const emit = defineEmits<{
  (e: "click"): void;
}>();

const { t } = useI18n();
const { createAddOrderPaymentDisableRules } = useDisableRules();

const disableRules = computed(() => createAddOrderPaymentDisableRules(() => props.orderStatus));
</script>

<template>
  <tooltip-button :rules="disableRules">
    <template #default="{ disabled }">
      <v-btn
        :disabled="disabled"
        class="text-uppercase font-size-12"
        color="primary"
        data-qa="order-payment-add"
        size="small"
        variant="text"
        @click="emit('click')"
      >
        <template #prepend>
          <v-icon size="16">mdi-plus</v-icon>
        </template>
        {{ t("payments.add-payment") }}
      </v-btn>
    </template>
  </tooltip-button>
</template>
